import StatCards from "@/features/stats/components/stat-cards";
import DilemmasPerTopicStats from "@/features/stats/components/dilemmas-per-topic-stats";
import { useFetchKpis } from "@/features/stats/hooks/useFetchKpis";
import GraphStats from "@/features/stats/components/graph-stats";
import StatsDateRangeSelector from "@/features/stats/components/stats-date-range-selector";
import { useAtomValue } from "jotai";
import { statsDateRangeAtom } from "@/stores/atoms/stats-date-range-atom";
import { useTranslation } from "react-i18next";

const StatisticsPage = () => {
  const { t } = useTranslation();
  const range = useAtomValue(statsDateRangeAtom);
  const { data: kpis, isLoading: isLoadingKpis } = useFetchKpis({
    start_date: range.start_date,
    end_date: range.end_date,
  });
  return (
    <div className="p-6 flex flex-col gap-4">
      <div className="mb-2 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <p className="font-semibold">{t("modules.stats.overview")}</p>
        <StatsDateRangeSelector />
      </div>
      <StatCards
        isLoading={isLoadingKpis}
        data={{
          kpis: kpis ?? null,
        }}
      />
      <div className="flex flex-col lg:flex-row-reverse items-start gap-4">
        <DilemmasPerTopicStats />
        <GraphStats />
      </div>
    </div>
  );
};

export default StatisticsPage;
